import api from "../utils/api";
import { UnitModel, AddUnitModel, UnitModelBase, DeleteUnitModel } from "../units/UnitModels";
import { LocationModel, PersonModel, FilterInfo, DeletedReasonModel, CompanyDataModel, PhoneNumberModel, EmailModel } from "../common/models/CommonModels";
import * as moment from 'moment';
import { createFilterUrl } from "./apiFilterUtils";
import { RecurrenceModel } from "../common/models/Recurrence";

const getEndpoint = "api/units";

interface UnitDto extends UnitModelBase<LocationModel, string> {
    id: string;
    company: CompanyDataModel<PhoneNumberModel, EmailModel>;
    coordinator: PersonModel;
    reportNumber: string;
    recurrence: RecurrenceModel
}

export const getUnits = (filters?: FilterInfo): Promise<UnitModel[]> => {

    const filterUrl = createFilterUrl(filters);

    return api.get(getEndpoint + filterUrl).then(response => {
        if (response.status === 200) {
            const data = <UnitDto[]>response.data;
            return data.map(item => {
                return {
                    ...item,
                    readyTime: moment(item.readyTime),
                    deliveryTime: moment(item.deliveryTime),
                    deletedAt: item.deletedAt ? moment(item.deletedAt) : undefined,
                    isOwn: false,
                    isOwnCompany: false,
                    recurrence: {
                        ...item.recurrence,
                        startDate: item.recurrence.startDate ?
                            moment(item.recurrence.startDate) : item.recurrence.startDate,
                        endDate: item.recurrence.endDate ?
                            moment(item.recurrence.endDate) : item.recurrence.endDate
                    }
                }
            });
        }

        return [];
    }).catch(error => {
        return [];
    });
}

export const addUnit = (unit: AddUnitModel) => {
    const unitData = {
        ...unit,
        readyTime: moment(unit.readyTime).format(),
        deliveryTime: moment(unit.deliveryTime).format()
    }

    return api.post("api/units", unitData).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    }).catch(error => {
        return false;
    });
}

export const editUnit = (unit: AddUnitModel) => {

    const id = unit.id;

    const unitData = {
        ...unit,
        readyTime: moment(unit.readyTime).format(),
        deliveryTime: moment(unit.deliveryTime).format()
    }

    return api.put(`api/units/${id}`, unitData).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    }).catch(error => {
        return false
    });
}

export const deleteUnit = (data: DeleteUnitModel) => {
    return api.post("api/units/delete", data).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    });
}

export const getDeletedReasons = () => {
    return api.get("api/units/deletedreasons").then(response => {
        if (response.status === 200) {
            const res: DeletedReasonModel[] = <DeletedReasonModel[]>response.data;
            return res;
        }

        return [];
    })
}

export const sendEmail = (id: string, message: string, emailAddress: string) => {
    return api.post(`api/units/${id}/sendemail`, { emailAddress, message })
    .then(response => response.status === 200)
}

export const sendEmailToReporter = (id: string, message: string) => {
    return api.post(`api/units/${id}/sendemailtoreporter`, { message })
    .then(response => response.status === 200)
}


// WEBPACK FOOTER //
// ./src/api/unitsApi.ts